// useMediaQuery — assina uma media query via matchMedia com useSyncExternalStore.
// SSR-safe: o server snapshot é sempre false (sem window). Fora do React tree
// nenhum listener fica pendurado — o unsubscribe remove o change handler.
import { useCallback, useSyncExternalStore } from 'react';
import { MEDIA } from '@/config/breakpoints';

export function useMediaQuery(query: string): boolean {
  const subscribe = useCallback(
    (onChange: () => void) => {
      if (typeof window === 'undefined' || !window.matchMedia) return () => {};
      const mql = window.matchMedia(query);
      mql.addEventListener('change', onChange);
      return () => mql.removeEventListener('change', onChange);
    },
    [query],
  );

  const getSnapshot = useCallback(() => {
    if (typeof window === 'undefined' || !window.matchMedia) return false;
    return window.matchMedia(query).matches;
  }, [query]);

  // Server snapshot fixo em false — evita hydration mismatch (assume desktop).
  const getServerSnapshot = () => false;

  return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
}

// Açúcar pro breakpoint mobile (≤768px) — o mais usado no shell responsivo.
export function useIsMobile(): boolean {
  return useMediaQuery(MEDIA.mobile);
}
